import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../../config';

@Injectable({
  providedIn: 'root'
})
export class PortfolioService {

  constructor(private http: HttpClient) { }

  addSession(data: any): Observable<any> {
    console.log("Adding clients", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "session", data).subscribe((res: any) => {

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  getSessions(data, learnerId, jobId): Observable<any> {
    // console.log("Adding clients", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.get(config.baseApiUrl + "session?_id=" + data + '&learnerId=' + learnerId + '&jobId=' + jobId).subscribe((res: any) => {
        console.log("get all sessions list", res);

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  getSessionsUsingJobId(data): Observable<any> {
    // console.log("Adding clients", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.get(config.baseApiUrl + "session/jobId?jobId=" + data).subscribe((res: any) => {

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  deleteSession(id, type) {
    return new Observable((observer) => {
      this.http.delete(config.baseApiUrl + "session?_id=" + id + '&sessionType=' + type).subscribe((res: any) => {
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        });

    })
  }

  editSession(data: any): Observable<any> {
    console.log("Edit Sessions", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "session", data).subscribe((res: any) => {
        console.log("Edited Session : ", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  getSessionFiles(id, sessionType) {
    console.log("Getting Files");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "session/files?_id=" + id + '&sessionType=' + sessionType).subscribe((res: any) => {
        console.log("Get Files Response : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }

  getClassromGroupedByCourseId(data): Observable<any> {
    
    return new Observable<any>((observer) => {
      console.log("Observable");
          observer.complete();
    });

  }

  getClassromGroupedByJobId(data): Observable<any> {
    // console.log("Adding clients", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.get(config.baseApiUrl + "learner-portfolio/submission/classroom?jobId=" + data).subscribe((res: any) => {

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  getStatusGroupedByJobId(data): Observable<any> {
    // console.log("Adding clients", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.get(config.baseApiUrl + "learner-portfolio/unit-status?jobId=" + data).subscribe((res: any) => {

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  changeUnitStatus(data) {
    console.log("Getting files");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "learner-portfolio/unit-status", data).subscribe((res: any) => {
        console.log("Get materials : ", res);
        observer.next(res.data);
        observer.complete();
      })

    });
  }


  portfolioSubmission(body) {
    console.log("Getting files");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "learner-portfolio/submission/job", body).subscribe((res: any) => {
        console.log("Get materials : ", res);
        observer.next(res.data.assign);
        observer.complete();
      })

    });
  }

  deleteSessionFiles(id, sessionType) {
    console.log("Getting Files");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.delete(config.baseApiUrl + "session/files?_id=" + id + '&sessionType=' + sessionType).subscribe((res: any) => {
        console.log("Get Files Response : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }

}
